import React from 'react';

import styled from 'styled-components';

const Container = styled.div`
  font-size: 14px;
`;

type Props = {
  yearOpened: number;
  dataTestId?: string;
};

const CMASummaryTableDataYearOpened = ({ yearOpened, dataTestId }: Props) => <Container data-test-id={dataTestId}>{yearOpened}</Container>;

export default CMASummaryTableDataYearOpened;
